import {
  NJInlineMessage,
  NJLink,
} from "@engie-group/fluid-design-system-react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export const RouteErrorFallback = () => {
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "var(--nj-semantic-color-background-neutral-primary-default)",
      }}
    >
      <NJInlineMessage>
        <span data-child-name="njInlineMessageTitle">
          <b>Erreur</b> Impossible d'accéder à l'application
        </span>
        {is404 ? (
          <div>
            La page que vous recherchez n'existe pas.{" "}
            <NJLink href="/" variant="high_contrast">
              Retourner à la page d'accueil
            </NJLink>
          </div>
        ) : (
          <div>
            Une erreur s'est produite lors de l'accès à l'application.{" "}
            <NJLink href="" variant="high_contrast">
              recharger la page
            </NJLink>
          </div>
        )}
      </NJInlineMessage>
    </div>
  );
};
